import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./BookingDetailPage.css";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const BookingDetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate(); // ✅ FIXED

  let state = location.state;

  // fallback
  if (!state) {
    const saved = localStorage.getItem("bookingData");
    state = saved ? JSON.parse(saved) : null;
  }

  if (!state || !state.carData) {
    return <h2 style={{ textAlign: "center" }}>No Booking Data Found</h2>;
  }

  const {
    carData,
    extraCharges = 0,
    fuelCharges = 0,
    driverCharges = 0,
    nightCharges = 0,
    bookingDate,
    bookingTime,
    pickup,
    drop,
  } = state;

  const totalPrice =
    carData.price + extraCharges + fuelCharges + driverCharges + nightCharges;


  const handleConfirm = () => {
    navigate("/traveller-detail-page", {
      state: {
        ...state,
        totalPrice,
      },
    });
  };
return (
  <div className="car-booking-page">
    {/* LEFT SIDE - CAR */}
    <div className="car-booking-left-section">
      <div className="car-booking-card">
        <img
          src={carData.img || "https://source.unsplash.com/800x400/?car"}
          alt={carData.name}
          className="car-img"
          onError={(e) => {
            e.target.src = "https://source.unsplash.com/800x400/?car";
          }}
        />

        <div className="car-booking-content">
          <h2>{carData.name}</h2>
          <p className="car-meta">
            {carData.type} • {carData.fuel} • {carData.capacity}
          </p>
        </div>
      </div>

      {/* TRIP INFO */}
      <div className="booking-car-card">
        <h3>Trip Details</h3>
        <p>
          <b>Pickup:</b> {pickup}
        </p>
        <p>
          <b>Drop:</b> {drop}
        </p>
        <p>
          <b>Date:</b> {formatDate(bookingDate)}
        </p>
        <p>
          <b>Time:</b> {bookingTime}
        </p>
      </div>

      {/* INCLUSIONS */}
      <div className="card green">
        <h3>Inclusions & Exclusions</h3>
        <ul>
          <li className="ok">Free 100km fuel included</li>
          <li className="ok">24/7 Roadside Assistance</li>
          <li className="no">Interstate taxes not included</li>
          <li className="no">Parking and Toll charges</li>
        </ul>
      </div>
    </div>

    {/* RIGHT SIDE - PRICE */}
    <div className="car-booking-right-section">
      <div className="car-booking-card">
        <h3>Price Breakdown</h3>

        <div className="row">
          <span>Base Price</span>
          <span>₹{carData.price}</span>
        </div>

        <div className="row">
          <span>Extra Charges</span>
          <span>₹{extraCharges}</span>
        </div>

        <div className="row">
          <span>Fuel</span>
          <span>₹{fuelCharges}</span>
        </div>

        <div className="row">
          <span>Driver</span>
          <span>₹{driverCharges}</span>
        </div>

        <div className="row">
          <span>Night Charges</span>
          <span>₹{nightCharges}</span>
        </div>

        <hr />

        <div className="total">
          <span>Total</span>
          <span>₹{totalPrice}</span>
        </div>
      </div>

      <button className="btn" onClick={handleConfirm}>
        Confirm Booking
      </button>
    </div>
  </div>
);

   
};

export default BookingDetailPage;
